exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dup-deliverable-detail[data-v-35672004] {\n  padding: 20px;\n  background-color: #fff;\n}\n.dup-deliverable-detail .dup-preview-description[data-v-35672004] {\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 8px;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  background: #fafafa;\n}\n.edit-deliverable-modal .deliverable-title[data-v-35672004] {\n  font-size: 30px;\n  color: #2d2d2d;\n  font-weight: 600;\n  line-height: 1em;\n}", ""]);

// exports
